<template>
  <div v-if="images.length || attribute" class="sign-gift-details">
    <div v-if="images.length" class="sign-gift-images" :aria-label="`${prizeName || '礼品'}图片`">
      <img v-for="(url, index) in images" :key="`${index}:${url}`" :src="url" :alt="`${prizeName || '礼品'} ${index + 1}`" loading="lazy" @error="markFailed(url)" />
    </div>
    <p v-if="attribute" class="sign-gift-attribute">{{ attribute }}</p>
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue';
import { legacySignImages } from '../../services/activities/legacySignPresentation.mjs';
const props = defineProps({ imageUrls: { type: Array, default: () => [] }, attribute: { type: String, default: '' }, prizeName: { type: String, default: '' } });
const failed = ref([]);
const images = computed(() => legacySignImages(props.imageUrls).filter(url => !failed.value.includes(url)));
function markFailed(url) { if (!failed.value.includes(url)) failed.value.push(url); }
watch(() => props.imageUrls, () => { failed.value = []; });
</script>
<style scoped>
.sign-gift-details { min-width: 0; margin-top: 8px; }
.sign-gift-images { display: flex; gap: 8px; flex-wrap: wrap; }
.sign-gift-images img { width: 72px; height: 72px; max-width: 100%; object-fit: contain; }
.sign-gift-attribute { margin: 8px 0 0; color: var(--kg-text-secondary, var(--act-secondary, #616783)); font-size: 13px; line-height: 1.7; overflow-wrap: anywhere; white-space: pre-wrap; }
@media (max-width: 480px) { .sign-gift-images img { width: 64px; height: 64px; } }
</style>
